"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rofrano": {
    "ca543ec4": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "skipSearch": false
    }],
    "abbenante": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3a2ff00": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "skipSearch": false
    }],
    "fornillo": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16166772": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "skipSearch": false
    }],
    "pozzillo-borsito": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "744dbd0a": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "skipSearch": false
    }],
    "provitera": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c6757db": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "skipSearch": false
    }],
    "san-leo": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c81ed8c": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "skipSearch": false
    }],
    "treppaoli": [{
      "hkey": "d522ce84",
      "slug": "rofrano",
      "name": "Rofrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;